import { catchError, map, of } from 'rxjs';
import { NgxMaskDirective } from 'ngx-mask';
import { environment } from 'src/environments/environment';
import { SelectPesquisavelService } from '@shared/components/select-pesquisavel/select-pesquisavel.service';
import {
  PesquisaCodigoTributacaoModalComponent,
  PesquisaCodigoTributacaoModalData,
  PesquisaCodigoTributacaoModalResult,
} from '@shared/components/pesquisa-codigo-tributacao-modal/pesquisa-codigo-tributacao-modal.component';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule, DatePipe, formatDate } from '@angular/common';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { AlertCardComponent } from '@shared/components/alert-card/alert-card.component';
import { AlertCardTimedComponent } from '@shared/components/alert-card-timed/alert-card-timed.component';
import { EmptyListComponent } from '@shared/components/empty-list/empty-list.component';
import { ExtracaoDadosData, ExtracaoDadosModalComponent, FiltroExtracao } from '@shared/components/extracao-dados-modal/extracao-dados-modal.component';
import { HeaderComponent } from '@shared/components/header/header.component';
import { LoadingBoxDefaultListComponent } from '@shared/components/loading-box-default-list/loading-box-default-list.component';
import { SelectPesquisavelComponent } from '@shared/components/select-pesquisavel/select-pesquisavel.component';
import { OrigemPedidoExportacaoEnum } from '@shared/enums/batch-extracao-dados/origem-pedido-exportacao.enum';
import { TipoExtracaoEnum } from '@shared/enums/batch-extracao-dados/tipo-extracao.enum';
import { DisponibilidadeDocumentoSefazEnum } from '@shared/enums/dfe/disponibilidade-documento-sefaz.enum';
import { ModeloDocumentoEnum } from '@shared/enums/dfe/modelo-documento.enum';
import { PeriodoBuscaEnum } from '@shared/enums/dfe/periodo-busca.enum';
import { StatusDocumentoEnum } from '@shared/enums/dfe/status-documento.enum';
import { TipoEventoNFeEnum } from '@shared/enums/dfe/tipo-evento-nfe.enum';
import { OrigemDocumentoFiscalRecebidoEnum } from '@shared/enums/repo-dfe/origem-documento-fiscal-recebido.enum';
import { FuncionalidadeEnum } from '@shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '@shared/enums/usuario/modulo.enum';
import { classeBadgeManifestacao } from '@shared/helpers/nota-fiscal-entrada-status.helper';
import { normalizarValorOrdenacao } from '@shared/helpers/ordenacao-tabela.helper';
import { AbntPipe } from '@shared/pipes/abnt.pipe';
import { AlertService, AlertType } from '@shared/services/alert.service';
import { CertificadoEmpresaA1Service } from '@shared/services/apis/dfe/certificado_empresa_a1.service';
import { ConfiguracaoBuscaSefazService } from '@shared/services/apis/dfe/configuracao-busca-sefaz.service';
import { ModeloDocumentoService } from '@shared/services/apis/dfe/modelo-documento.service';
import { PainelDFeRecebidoService } from '@shared/services/apis/repo-dfe/painel-dfe-recebido.service';
import { DacteService } from '@shared/services/apis/report/dacte.service';
import { DanfeService } from '@shared/services/apis/report/danfe.service';
import { AuthService } from '@shared/services/apis/usuario/auth.service';
import { CustomDateAdapter } from '@shared/services/custom-date-adapter';
import { MaskService } from '@shared/services/mask.service';
import { ModeloDocumento } from '@shared/services/models/dfe/modelo-documento.model';
import { Empresa } from '@shared/services/models/usuario/empresa.model';
import { DownloadDocumentosFiscaisRecebidosRequest } from '@shared/services/requests/repo-dfe/download-documentos-fiscais-recebidos.request';
import { ListarDocumentosFiscaisRecebidosRequest } from '@shared/services/requests/repo-dfe/listar-documentos-fiscais-recebidos.request';
import { GerarDacteRequest } from '@shared/services/requests/report/gerar-dacte.request';
import { GerarDanfeRequest } from '@shared/services/requests/report/gerar-danfe.request';
import { StatusBuscaSefazResponse } from '@shared/services/responses/dfe/status-busca-sefaz.response';
import { ControleAcessoSefazStruct } from '@shared/services/structs/dfe/controle-acesso-sefaz.struct';
import { DownloadDocumentosFiscaisRecebidosResponse } from '@shared/services/responses/repo-dfe/download-documentos-fiscais-recebidos.response';
import { UsuarioLoginResponse } from '@shared/services/responses/usuario/usuario-login.response';
import { DocumentoFiscalRecebidoDownloadStruct } from '@shared/services/structs/repo-dfe/documento-fiscal-recebido-download.struct';
import { DocumentoFiscalRecebidoListStruct } from '@shared/services/structs/repo-dfe/documento-fiscal-recebido-list.struct';
import { UtilService } from '@shared/services/util.service';
import { LimitDateValidator } from '@shared/validators/limit-date.validator';
import { ModalHistoricoSefazComponent } from './modal-historico-sefaz/modal-historico-sefaz.component';

@Component({
    selector: 'app-painel-nota-recebida',
    standalone: true,
    imports: [
        NgxMaskDirective,
        CommonModule,
        ReactiveFormsModule,
        MatBadgeModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatSortModule,
        MatTableModule,
        MatTooltipModule,
        DatePipe,
        AbntPipe,
        NgxMaskPipe,
        AlertCardComponent,
        AlertCardTimedComponent,
        EmptyListComponent,
        HeaderComponent,
        LoadingBoxDefaultListComponent,
        SelectPesquisavelComponent,
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        { provide: DateAdapter, useClass: CustomDateAdapter },
        provideNgxMask()
    ],
    templateUrl: './painel-nota-recebida.component.html',
    styleUrls: ['./painel-nota-recebida.component.css'],
})
export class PainelNotaRecebidaComponent implements OnInit, OnDestroy {
    readonly masks = MaskService.getMasks();
    readonly moduloEnum = ModuloEnum.NotasFiscais;
    readonly funcionalidadeEnum = FuncionalidadeEnum.NotasFiscais_PainelNotaRecebida;
    readonly modeloDocumentoEnum = ModeloDocumentoEnum;
    readonly tipoExtracaoEnum = TipoExtracaoEnum;
    readonly periodoEnum = PeriodoBuscaEnum;
    readonly limiteMeses = 3;
    readonly cfopMaskPatterns = { '0': { pattern: /[0-9?]/ } };
    readonly opcoesPeriodo = [
        { periodo: PeriodoBuscaEnum.Hoje, rotulo: 'hoje' },
        { periodo: PeriodoBuscaEnum.DaSemana, rotulo: 'desta semana' },
        { periodo: PeriodoBuscaEnum.DoMes, rotulo: 'do mês' },
        { periodo: PeriodoBuscaEnum.Ultimos30Dias, rotulo: 'últimos 30 dias' },
        { periodo: PeriodoBuscaEnum.DoIntervalo, rotulo: 'do intervalo' },
    ];
    readonly displayedColumns = ['select', 'tipoNota', 'numeroNota', 'dataHoraEmissao', 'cfop', 'emitente', 'destinatario', 'valor', 'status', 'acoes'];
    readonly dataSource = new MatTableDataSource<DocumentoFiscalRecebidoListStruct>();
    readonly selection = new SelectionModel<DocumentoFiscalRecebidoListStruct>(true, []);
    readonly filterForm = this.formBuilder.group({
        pesquisar: [''],
        tiposNota: [[] as number[]],
        listIdEmpresa: [[] as number[]],
        serie: [''],
        cfop: [''],
        dataDe: [null as Date | null],
        dataAte: [null as Date | null],
        periodoSelecionado: [PeriodoBuscaEnum.DoMes],
    }, {
        validators: LimitDateValidator.rangeLimit(this.limiteMeses)
    });

    listaModeloDocumento: ModeloDocumento[] = [];
    listaEmpresas: Empresa[] = [];
    empresasSemCertificado: Empresa[] = [];
    isSingleCompanyView = false;
    controleAcessoSefazNFe: ControleAcessoSefazStruct | undefined;
    controleAcessoSefazCTe: ControleAcessoSefazStruct | undefined;
    isBuscaAutomatica = false;
    mensagemErroSefaz = '';
    showAlertCard = false;
    showSefazError = false;
    isLoading = false;
    isLoadingInitialData = true;
    isLoadingDownload = false;
    ultimaPagina = false;
    paginaAtual = 0;
    fullListSize = 0;
    valorTotal = 0;
    isMobileDrawerOpen = false;

    @ViewChild(MatSort) set matSort(sort: MatSort) {
        this.dataSource.sort = sort;
        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'tipoNota': return normalizarValorOrdenacao(item.modeloDocumento);
                case 'numeroNota': return normalizarValorOrdenacao(item.numeroSerie);
                case 'dataHoraEmissao': return normalizarValorOrdenacao(item.emissao);
                case 'status': return normalizarValorOrdenacao(this.obterDescricaoSituacaoDocumento(item));
                default: return normalizarValorOrdenacao((item as any)[property]);
            }
        };
    }

    constructor(
    private selectPesquisavelService: SelectPesquisavelService,

        private formBuilder: FormBuilder,
        private dfeRecebidoService: PainelDFeRecebidoService,
        private certificadoEmpresaA1Service: CertificadoEmpresaA1Service,
        private configuracaoBuscaSefazService: ConfiguracaoBuscaSefazService,
        private authService: AuthService,
        private alertService: AlertService,
        private router: Router,
        private utilService: UtilService,
        private danfeService: DanfeService,
        private dialog: MatDialog,
        private dacteService: DacteService,
        private modeloDocumentoService: ModeloDocumentoService,
    ) { }

    ngOnInit(): void {
        this.getUltimoAcessoSefaz();
        this.loadInitialData();
    }

    ngOnDestroy(): void {
        this.utilService.salvarFiltro(this.moduloEnum, this.funcionalidadeEnum, this.filterForm,
            ['/notas-fiscais/notas-recebidas/nfe/detalhe-nota', '/notas-fiscais/notas-recebidas/cte/detalhe-nota']);
    }

    get periodoSelecionado(): PeriodoBuscaEnum {
        return this.filterForm.get('periodoSelecionado')!.value ?? PeriodoBuscaEnum.DoMes;
    }

    get periodoLabel(): string {
        return this.opcoesPeriodo.find(x => x.periodo === this.periodoSelecionado)?.rotulo ?? '';
    }

    get qtdFiltrosAvancados(): number {
        const value = this.filterForm.getRawValue();
        return (
            (value.tiposNota?.length ? 1 : 0) +
            (!this.isSingleCompanyView && value.listIdEmpresa?.length ? 1 : 0) +
            (value.serie ? 1 : 0) +
            (value.cfop ? 1 : 0)
        );
    }

    /** Sem destinatário escolhido, a busca considera todas as empresas disponíveis. */
    private get idsEmpresa(): number[] {
        const listIdEmpresa = this.filterForm.getRawValue().listIdEmpresa;
        return listIdEmpresa?.length ? listIdEmpresa : this.listaEmpresas.map(x => x.idEmpresa);
    }

    obterDescricaoSituacaoDocumento(item: DocumentoFiscalRecebidoListStruct): string {
        if (item.idStatusDocumento === StatusDocumentoEnum.Cancelado) return 'Cancelado';

        switch (item.idTipoEventoManifestacaoAtual) {
            case TipoEventoNFeEnum.ConfirmacaoOperacao: return 'Confirmação da Operação';
            case TipoEventoNFeEnum.CienciaEmissao: return 'Ciência da Emissão';
            case TipoEventoNFeEnum.DesconhecimentoOperacao: return 'Desconhecimento da Operação';
            case TipoEventoNFeEnum.OperacaoNaoRealizada: return 'Operação Não Realizada';
        }

        if (item.isManifestacaoConclusivaNaoIdentificada)
            return 'Manifestação conclusiva; tipo não identificado no histórico';

        if (item.descricaoSituacaoDocumento) return item.descricaoSituacaoDocumento;

        switch (item.idDisponibilidadeDocumentoSefaz) {
            case DisponibilidadeDocumentoSefazEnum.DocumentoCompleto: return 'Documento completo';
            case DisponibilidadeDocumentoSefazEnum.ResumoRecebido: return 'Resumo recebido';
            default: return 'Identificado';
        }
    }

    /** Mesma precedência de obterDescricaoSituacaoDocumento; manifestações usam as cores da Central de Notas. */
    classeBadgeStatus(item: DocumentoFiscalRecebidoListStruct): string {
        if (item.idStatusDocumento === StatusDocumentoEnum.Cancelado) return 'badge-vermelho';

        switch (item.idTipoEventoManifestacaoAtual) {
            case TipoEventoNFeEnum.ConfirmacaoOperacao:
            case TipoEventoNFeEnum.CienciaEmissao:
            case TipoEventoNFeEnum.DesconhecimentoOperacao:
            case TipoEventoNFeEnum.OperacaoNaoRealizada:
                return classeBadgeManifestacao(item.idTipoEventoManifestacaoAtual);
        }

        if (item.isManifestacaoConclusivaNaoIdentificada || item.descricaoSituacaoDocumento) return 'badge-cinza';

        switch (item.idDisponibilidadeDocumentoSefaz) {
            case DisponibilidadeDocumentoSefazEnum.DocumentoCompleto: return 'badge-verde';
            case DisponibilidadeDocumentoSefazEnum.ResumoRecebido: return 'badge-azul';
            default: return 'badge-cinza';
        }
    }

    loadInitialData(): void {
        this.isLoadingInitialData = true;
        this.modeloDocumentoService.listar().subscribe({
            next: (response) => {
                if (response.isError) {
                    this.alertService.show('Erro', response.errorDescription, AlertType.error);
                    this.isLoadingInitialData = false;
                    return;
                }

                this.listaModeloDocumento = response.modelos.filter(modelo =>
                    [ModeloDocumentoEnum.NFe, ModeloDocumentoEnum.CTe].includes(modelo.idModeloDocumento));
                this.loadEmpresas();
            },
            error: () => {
                this.isLoadingInitialData = false;
            }
        });
    }

    loadEmpresas(): void {
        const userInfo: UsuarioLoginResponse = this.authService.getUserInfos();
        const empresaAtual: Empresa | undefined = userInfo.listaEmpresa.find(x => x.idEmpresa == userInfo.idEmpresa);
        if (!userInfo.listaEmpresasDoGrupo?.length) {
            this.isSingleCompanyView = true;
            this.listaEmpresas = empresaAtual ? [empresaAtual] : [];
        } else if (!userInfo.empresaPrincipalGrupo || userInfo.listaEmpresasDoGrupo.length === 1) {
            this.isSingleCompanyView = true;
            this.listaEmpresas = userInfo.listaEmpresasDoGrupo.filter(x => x.idEmpresa == userInfo.idEmpresa);
        } else {
            this.isSingleCompanyView = false;
            this.listaEmpresas = userInfo.listaEmpresasDoGrupo;
        }

        this.loadFilters();
        if (this.isSingleCompanyView) {
            this.filterForm.get('listIdEmpresa')?.setValue(this.listaEmpresas[0] ? [this.listaEmpresas[0].idEmpresa] : []);
            this.filterForm.get('listIdEmpresa')?.disable();
        }
        this.getCertificadoValido();
    }

    /** Filtro salvo antes do seletor de período (sem periodoSelecionado) é descartado. */
    loadFilters(): void {
        const filtroSalvo = this.utilService.obterFiltro(this.moduloEnum, this.funcionalidadeEnum);
        if (!filtroSalvo?.periodoSelecionado) return;
        this.filterForm.patchValue(filtroSalvo);
        const modelosPermitidos = this.listaModeloDocumento.map(x => x.idModeloDocumento);
        this.filterForm.get('tiposNota')?.setValue((this.filterForm.get('tiposNota')?.value ?? [])
            .filter((id: number) => modelosPermitidos.includes(id)));
    }

    getUltimoAcessoSefaz(): void {
        this.configuracaoBuscaSefazService.getStatus().subscribe({
            next: (response: StatusBuscaSefazResponse) => {
                if (response.isError) {
                    return;
                }

                this.controleAcessoSefazNFe = response.controleAcessoSefazNFe || undefined;
                this.controleAcessoSefazCTe = response.controleAcessoSefazCTe || undefined;

                // A espera do 137 também bloqueia; o alerta de rejeição é só para o 656.
                if (this.controleAcessoSefazNFe?.isBloqueadoPorConsumoIndevido) {
                    this.mensagemErroSefaz = 'A sua última consulta foi rejeitada por consumo indevido! A Sefaz bloqueou a busca por 1 hora, pois outro sistema já está consultando este CNPJ gerando um concorrência de consumo. Verifique se há outro software realizando buscas automáticas.';
                    this.showSefazError = true;
                } else {
                    this.mensagemErroSefaz = '';
                    this.showSefazError = false;
                }

                if (response.configuracaoBuscaSefaz) {
                    this.isBuscaAutomatica = response.configuracaoBuscaSefaz.isBuscaAutomatica;
                }
            },
            error: () => { /* Silencioso */ }
        });
    }

    getCertificadoValido(): void {
        const listIdEmpresa: number[] = this.listaEmpresas.map(x => x.idEmpresa);

        this.certificadoEmpresaA1Service.validarCertificado(listIdEmpresa).subscribe({
            next: (response) => {
                if (response.isError) {
                    this.alertService.show('Erro', 'Não foi possível validar os certificados.', AlertType.error);
                    this.buscarNotas(true);
                    return;
                }

                this.listaEmpresas.forEach(empresa => {
                    const status = response.listEmpresaCertificadoValidoStruct.find(x => x.idEmpresa == empresa.idEmpresa);
                    empresa.certificadoValido = status?.certificadoValido ?? false;
                });
                this.buscarNotas(true);
            },
            error: () => {
                this.buscarNotas(true);
            }
        });
    }

    aplicarFiltros(): void {
        this.buscarNotas(true);
    }

    limparFiltros(): void {
        const listIdEmpresa = this.isSingleCompanyView ? this.filterForm.get('listIdEmpresa')?.value : [];
        this.filterForm.patchValue({
            pesquisar: '',
            tiposNota: [],
            listIdEmpresa,
            serie: '',
            cfop: '',
            dataDe: null,
            dataAte: null,
            periodoSelecionado: PeriodoBuscaEnum.DoMes,
        });
        this.buscarNotas(true);
    }

    buscarNotas(novaBusca: boolean): void {
        this.atualizarAlertasCertificado();
        if (this.mensagemErroSefaz) this.showSefazError = true;
        if (this.isLoading) return;
        if (novaBusca) {
            this.paginaAtual = 0;
            this.ultimaPagina = false;
            this.selection.clear();
            this.dataSource.data = [];
        }
        this.isLoading = true;

        const form = this.filterForm.getRawValue();
        const { dataDe, dataAte } = this.getPeriodo();
        const request: ListarDocumentosFiscaisRecebidosRequest = {
            modelosDocumento: form.tiposNota ?? [],
            idsEmpresa: this.idsEmpresa,
            // Dia local sem fuso: o JSON de um Date sairia em UTC ("...Z") e a API monta a faixa pelo fuso da empresa.
            dataDe: formatDate(dataDe, 'yyyy-MM-dd', 'pt-BR'),
            dataAte: formatDate(dataAte, 'yyyy-MM-dd', 'pt-BR'),
            pesquisar: form.pesquisar || null,
            cfop: form.cfop || null,
            serie: form.serie || null
        };

        this.dfeRecebidoService.getAll(request, this.paginaAtual).subscribe({
            next: (response) => {
                this.isLoading = false;
                this.isLoadingInitialData = false;
                if (response.isError) {
                    this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
                    return;
                }
                this.dataSource.data = [...this.dataSource.data, ...(response.documentos || [])];
                this.fullListSize = response.fullListSize;
                this.valorTotal = response.valorTotal;
                this.ultimaPagina = this.dataSource.data.length >= response.fullListSize;
            },
            error: (error) => {
                this.isLoading = false;
                this.isLoadingInitialData = false;
                this.alertService.show('Erro inesperado', error.message, AlertType.error);
            },
        });
    }

    atualizarAlertasCertificado(): void {
        const idsSelecionados = this.idsEmpresa;
        this.empresasSemCertificado = this.listaEmpresas.filter(emp =>
            idsSelecionados.includes(emp.idEmpresa) && !emp.certificadoValido
        );
        this.showAlertCard = this.empresasSemCertificado.length > 0;
    }

    closeAlertCard(): void {
        this.showAlertCard = false;
        this.showSefazError = false;
    }

    proximaPagina(): void {
        if (this.ultimaPagina) return;
        this.paginaAtual++;
        this.buscarNotas(false);
    }

    selecionarPeriodo(periodo: PeriodoBuscaEnum, event: Event): void {
        this.filterForm.get('periodoSelecionado')?.setValue(periodo);
        if (periodo === PeriodoBuscaEnum.DoIntervalo) {
            event.stopPropagation();
            return;
        }
        this.filterForm.patchValue({ dataDe: null, dataAte: null });
        this.buscarNotas(true);
    }

    aplicarIntervalo(trigger: MatMenuTrigger): void {
        const value = this.filterForm.getRawValue();
        if (!value.dataDe || !value.dataAte) {
            this.alertService.show('Aviso', 'Informe a data inicial e a data final do intervalo.', AlertType.warning);
            return;
        }
        if (this.filterForm.invalid) {
            this.filterForm.markAllAsTouched();
            return;
        }
        trigger.closeMenu();
        this.buscarNotas(true);
    }

    cancelarIntervalo(trigger: MatMenuTrigger): void {
        this.filterForm.patchValue({ periodoSelecionado: PeriodoBuscaEnum.DoMes, dataDe: null, dataAte: null });
        trigger.closeMenu();
        this.buscarNotas(true);
    }

    onDateInput(event: Event, controlName: string): void {
        MaskService.onDateInput(event, this.filterForm.get(controlName));
    }

    toggleGavetaMobile(): void {
        this.isMobileDrawerOpen = !this.isMobileDrawerOpen;
    }

    fecharGavetaMobile(): void {
        this.isMobileDrawerOpen = false;
    }

    isAllSelected(): boolean {
        return this.selection.selected.length === this.dataSource.data.length;
    }

    toggleAllRows(): void {
        this.isAllSelected() ? this.selection.clear() : this.selection.select(...this.dataSource.data);
    }

    podeVerDetalhes(nota: DocumentoFiscalRecebidoListStruct): boolean {
        return nota.idModeloDocumento === ModeloDocumentoEnum.NFe || nota.idModeloDocumento === ModeloDocumentoEnum.CTe;
    }

    verDetalhes(nota: DocumentoFiscalRecebidoListStruct): void {
        const modelo = nota.idModeloDocumento === ModeloDocumentoEnum.NFe ? 'nfe'
            : nota.idModeloDocumento === ModeloDocumentoEnum.CTe ? 'cte' : null;
        if (!modelo) return;
        this.router.navigate(['/notas-fiscais/notas-recebidas', modelo, 'detalhe-nota', nota.idDFeRecebido],
            { queryParams: { origemDocumentoFiscalRecebido: nota.origemDocumentoFiscalRecebido } });
    }

    visualizarPdf(nota: DocumentoFiscalRecebidoListStruct): void {
        if (nota.idModeloDocumento == ModeloDocumentoEnum.CTe) {
            this.visualizarDacte(nota);
        } else {
            this.visualizarDanfe(nota);
        }
    }

    podeVisualizarPdf(nota: DocumentoFiscalRecebidoListStruct): boolean {
        return !!nota.xmlPath
            && nota.possuiXmlCompleto
            && (nota.idModeloDocumento === ModeloDocumentoEnum.NFe || nota.idModeloDocumento === ModeloDocumentoEnum.CTe);
    }

    /** Motivo exibido quando a visualização do PDF está desabilitada. */
    tooltipVisualizarPdf(nota: DocumentoFiscalRecebidoListStruct): string {
        if (!nota.possuiXmlCompleto)
            return 'Visualização não disponível para resumo de nota.';
        if (!nota.xmlPath)
            return 'XML não encontrado para gerar o PDF.';
        return 'PDF disponível apenas para NF-e e CT-e.';
    }

    visualizarDanfe(nota: DocumentoFiscalRecebidoListStruct): void {
        if (!nota.xmlPath) {
            this.alertService.show('Atenção', 'XML não encontrado para gerar a DANFE.', AlertType.warning);
            return;
        }
        nota.isLoadingDanfe = true;
        const request = new GerarDanfeRequest();
        request.nomeXml = nota.xmlPath;
        request.isDocumentoRecebido = true;
        request.caminhoGcs = nota.origemDocumentoFiscalRecebido === OrigemDocumentoFiscalRecebidoEnum.EstruturaNova ? nota.xmlPath : undefined;

        this.danfeService.gerarDANFe(request).subscribe({
            next: (pdfBlob) => {
                if (pdfBlob.type === 'application/pdf') {
                    const pdfUrl = URL.createObjectURL(pdfBlob);
                    window.open(pdfUrl, '_blank');
                    URL.revokeObjectURL(pdfUrl);
                } else {
                    this.alertService.show('Erro', 'Não foi possível gerar o PDF da nota.', AlertType.error);
                }
                nota.isLoadingDanfe = false;
            },
            error: () => {
                this.alertService.show('Erro inesperado', 'Ocorreu uma falha ao tentar gerar a DANFE.', AlertType.error);
                nota.isLoadingDanfe = false;
            }
        });
    }

    visualizarDacte(nota: DocumentoFiscalRecebidoListStruct): void {
        if (!nota.xmlPath) {
            this.alertService.show('Atenção', 'XML não encontrado para gerar a DACTE.', AlertType.warning);
            return;
        }
        nota.isLoadingDanfe = true;
        const request = new GerarDacteRequest();
        request.nomeXml = nota.xmlPath;
        request.isDocumentoRecebido = true;
        request.caminhoGcs = nota.origemDocumentoFiscalRecebido === OrigemDocumentoFiscalRecebidoEnum.EstruturaNova ? nota.xmlPath : undefined;

        this.dacteService.gerarDACTe(request).subscribe({
            next: (pdfBlob) => {
                if (pdfBlob.type === 'application/pdf') {
                    const pdfUrl = URL.createObjectURL(pdfBlob);
                    window.open(pdfUrl, '_blank');
                    URL.revokeObjectURL(pdfUrl);
                } else {
                    this.alertService.show('Erro', 'Não foi possível gerar o PDF da nota.', AlertType.error);
                }
                nota.isLoadingDanfe = false;
            },
            error: () => {
                this.alertService.show('Erro inesperado', 'Ocorreu uma falha ao tentar gerar a DACTE.', AlertType.error);
                nota.isLoadingDanfe = false;
            }
        });
    }

    baixarXml(nota: DocumentoFiscalRecebidoListStruct): void {
        nota.isLoading = true;
        const downloadDocumento = new DocumentoFiscalRecebidoDownloadStruct();
        downloadDocumento.idDFeRecebido = nota.idDFeRecebido;
        downloadDocumento.idModeloDocumento = nota.idModeloDocumento!;
        downloadDocumento.origemDocumentoFiscalRecebido = nota.origemDocumentoFiscalRecebido;
        const request = new DownloadDocumentosFiscaisRecebidosRequest();
        request.documentos = [downloadDocumento];

        this.dfeRecebidoService.downloadDocumentos(request).subscribe({
            next: (response) => this.handleDownloadResponse(response, nota),
            error: (err) => {
                nota.isLoading = false;
                this.alertService.show('Erro', `Falha ao baixar XML: ${err.message}`, AlertType.error);
            }
        });
    }

    baixarNotasSelecionadas($event: Event): void {
        $event.stopPropagation();
        if (this.isLoadingDownload) return;

        if (this.selection.selected.length === 0) {
            this.alertService.show('Atenção', 'Selecione ao menos uma nota para baixar.', AlertType.warning);
            return;
        }

        this.isLoadingDownload = true;
        const request = new DownloadDocumentosFiscaisRecebidosRequest();

        this.selection.selected.forEach((nota: DocumentoFiscalRecebidoListStruct) => {
            const documento = new DocumentoFiscalRecebidoDownloadStruct();
            documento.idDFeRecebido = nota.idDFeRecebido;
            documento.idModeloDocumento = nota.idModeloDocumento!;
            documento.origemDocumentoFiscalRecebido = nota.origemDocumentoFiscalRecebido;
            request.documentos.push(documento);
        });

        this.dfeRecebidoService.downloadDocumentos(request).subscribe({
            next: (response) => this.handleDownloadResponse(response),
            error: (err) => {
                this.isLoadingDownload = false;
                this.alertService.show('Erro', `Falha ao baixar arquivos: ${err.message}`, AlertType.error);
            }
        });
    }

    private handleDownloadResponse(response: DownloadDocumentosFiscaisRecebidosResponse, nota?: DocumentoFiscalRecebidoListStruct): void {
        if (response.isError || !response.fileContentBase64) {
            this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
        } else {
            const byteCharacters = atob(response.fileContentBase64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: response.contentType });

            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = response.fileName || 'download.zip';
            link.click();
            URL.revokeObjectURL(link.href);
        }
        if (nota) nota.isLoading = false;
        this.isLoadingDownload = false;
    }

    fazerPedidoExtracao(idTipoExtracao: TipoExtracaoEnum): void {
        const titulo = idTipoExtracao === TipoExtracaoEnum.NotaRecebidaXml
            ? 'XML de todas as notas com filtro'
            : 'CSV da tabela com filtro';

        const formValue = this.filterForm.getRawValue();
        const { dataDe, dataAte } = this.getPeriodo();
        const idsEmpresa = this.idsEmpresa;
        const filtrosMapeados: FiltroExtracao[] = [];

        // As chaves (formControlName) são os nomes do PainelNotaRecebidaFilterStruct do worker de extração.
        if (formValue.tiposNota?.length) {
            filtrosMapeados.push({
                label: 'Tipos de Nota',
                formControlName: 'tiposNota',
                valor: formValue.tiposNota,
                valorExibicao: this.listaModeloDocumento
                    .filter(tipo => formValue.tiposNota!.includes(tipo.idModeloDocumento))
                    .map(tipo => tipo.nome)
            });
        }
        filtrosMapeados.push({
            label: 'Destinatários',
            formControlName: 'listIdEmpresa',
            valor: idsEmpresa,
            valorExibicao: this.listaEmpresas
                .filter(empresa => idsEmpresa.includes(empresa.idEmpresa))
                .map(empresa => empresa.nomeEmpresa)
        });
        filtrosMapeados.push({ label: 'Data Inicial', formControlName: 'dataDe', valor: formatDate(dataDe, 'yyyy-MM-dd', 'pt-BR'), valorExibicao: dataDe.toLocaleDateString('pt-BR') });
        filtrosMapeados.push({ label: 'Data Final', formControlName: 'dataAte', valor: formatDate(dataAte, 'yyyy-MM-dd', 'pt-BR'), valorExibicao: dataAte.toLocaleDateString('pt-BR') });
        if (formValue.pesquisar) {
            filtrosMapeados.push({ label: 'Pesquisa', formControlName: 'pesquisar', valor: formValue.pesquisar });
        }
        if (formValue.serie) {
            filtrosMapeados.push({ label: 'Série', formControlName: 'serie', valor: formValue.serie });
        }
        if (formValue.cfop) {
            filtrosMapeados.push({ label: 'CFOP', formControlName: 'cfop', valor: formValue.cfop });
        }

        const dialogData: ExtracaoDadosData = {
            titulo: titulo,
            tipoExtracao: idTipoExtracao,
            origemPedidoExportacao: OrigemPedidoExportacaoEnum.NotasFiscaisPainelNotasRecebidas,
            filtros: filtrosMapeados,
            possuiAutomacao: true,
        };

        this.dialog.open(ExtracaoDadosModalComponent, {
            data: dialogData,
            width: '800px',
            maxWidth: '95vw',
            maxHeight: '90vh',
            disableClose: true
        });
    }

    abrirModalHistoricoBusca(): void {
        const userInfo: UsuarioLoginResponse = this.authService.getUserInfos();
        this.dialog.open(ModalHistoricoSefazComponent, {
            data: {
                listaEmpresas: this.listaEmpresas,
                idEmpresaLogada: userInfo.idEmpresa,
                controleAcessoSefazNFe: this.controleAcessoSefazNFe ?? null,
                listaModeloDocumento: this.listaModeloDocumento
            },
            width: '800px',
            maxWidth: '95vw',
            maxHeight: '90vh',
            disableClose: true
        });
    }

    abrirConfiguracoes(): void {
        this.router.navigate(['/configuracoes/notas-fiscais/busca-nfe-sefaz']);
    }

    /** Presets calculados no dia local; o intervalo usa as datas digitadas. Meia-noite local, como o datepicker. */
    private getPeriodo(): { dataDe: Date; dataAte: Date } {
        const value = this.filterForm.getRawValue();
        if (this.periodoSelecionado === PeriodoBuscaEnum.DoIntervalo && value.dataDe && value.dataAte)
            return { dataDe: value.dataDe, dataAte: value.dataAte };

        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);
        const dataDe = new Date(hoje);
        switch (this.periodoSelecionado) {
            case PeriodoBuscaEnum.Hoje:
                break;
            case PeriodoBuscaEnum.DaSemana:
                dataDe.setDate(hoje.getDate() - 6);
                break;
            case PeriodoBuscaEnum.DoMes:
                dataDe.setDate(1);
                break;
            default:
                dataDe.setDate(hoje.getDate() - 29);
                break;
        }
        return { dataDe, dataAte: hoje };
    }

    pesquisarCfop(): void {
        if (this.filterForm.get('cfop')?.disabled) return;
        const ref = this.dialog.open(PesquisaCodigoTributacaoModalComponent, {
            width: '700px',
            maxWidth: '95vw',
            maxHeight: '85vh',
            panelClass: 'pesquisa-codigo-tributacao-dialog',
            data: {
                titulo: 'Pesquisar CFOP',
                buscarFn: (pesquisa: string) => this.selectPesquisavelService
                    .getSelectValues<{ codigo?: string; descricao: string }>(environment.urlApiMotorFiscal + 'Lookup/cfop', pesquisa)
                    .pipe(
                        map(list => ({
                            isError: false,
                            itens: list.map(i => ({ codigo: String(i.codigo ?? ''), descricao: i.descricao })),
                        })),
                        catchError(() => of({ isError: true, itens: [] })),
                    ),
                permitirManual: false,
                registrosIniciais: 20,
                valorInicial: this.filterForm.get('cfop')?.value ?? undefined,
            } satisfies PesquisaCodigoTributacaoModalData,
        });
        ref.afterClosed().subscribe((result: PesquisaCodigoTributacaoModalResult | null) => {
            if (!result?.selecionado) return;
            this.filterForm.get('cfop')?.setValue(result.selecionado.codigo.replace(/\D/g, ''));
            this.filterForm.get('cfop')?.markAsDirty();
        });
    }
}
